import { splitKeyWords, titleCaseWords } from "../strings.js";
export function defaultEntityTypeDisplayName(label) {
    const normalized = label.trim();
    if (!normalized)
        return label;
    return normalized
        .split(/\s+/)
        .map((word) => /^[A-Z0-9]+$/.test(word)
        ? word
        : `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
        .join(" ");
}
export function defaultEntityTypeDisplayArticle(name) {
    const firstLetter = name
        .trim()
        .replace(/^[^A-Za-z0-9]+/, "")
        .charAt(0)
        ?.toLowerCase();
    return firstLetter && "aeiou".includes(firstLetter) ? "an" : "a";
}
export function defaultEntityTypePluralLabel(name) {
    if (/^[A-Z0-9]+$/.test(name)) {
        return `${name}s`;
    }
    if (/(?:s|x|z|ch|sh)$/i.test(name)) {
        return `${name}es`;
    }
    if (/[^aeiou]y$/i.test(name)) {
        return `${name.slice(0, -1)}ies`;
    }
    return `${name}s`;
}
/**
 * The all-lowercase reading of an entity type key — `"decisionObjective"` → `"decision
 * objective"` — for labels that sit mid-sentence ("add a decision objective").
 *
 * Deliberately distinct from `humanizeKey`, which capitalizes the same words for standalone
 * display; both split the key with `splitKeyWords` so only the casing rule differs.
 */
export function labelFromEntityTypeKey(entityTypeKey) {
    return splitKeyWords(entityTypeKey).toLowerCase() || entityTypeKey;
}
export function getCompiledEntityTypeLabel(structure, entityTypeKey) {
    return (structure?.entityDisplays?.find((display) => display.entityTypeKey === entityTypeKey)?.label ??
        null);
}
export function getCompiledEntityTypePluralLabel(structure, entityTypeKey) {
    return (structure?.entityDisplays?.find((display) => display.entityTypeKey === entityTypeKey)
        ?.pluralLabel ?? null);
}
export function getEntityTypeLabelWithFallback(structure, entityTypeKey) {
    return (getCompiledEntityTypeLabel(structure, entityTypeKey) ?? labelFromEntityTypeKey(entityTypeKey));
}
export function getEntityTypePluralLabelWithFallback(structure, entityTypeKey) {
    return (getCompiledEntityTypePluralLabel(structure, entityTypeKey) ??
        defaultEntityTypePluralLabel(getEntityTypeLabelWithFallback(structure, entityTypeKey)));
}
export function getEntityTypeRouteLabelWithFallback(structure, entityTypeKey) {
    return titleCaseWords(defaultEntityTypeDisplayName(getEntityTypeLabelWithFallback(structure, entityTypeKey)));
}
